<template>
  <div class="content">
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.name"
          :label="$t('forms.labels.name')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="productSensorForm-name"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.make"
          :items="makes"
          :label="$t('forms.labels.make')"
          :rules="{ required: true }"
          hideDetails
          outlined
          data-cy="productSensorForm-make"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.model"
          :label="$t('forms.labels.model')"
          :rules="{ required: true }"

          hideDetails
          outlined
          required
          data-cy="productSensorForm-model"
          @input="updateData"
        />
      </v-col>
    </v-row>


    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.macAddress"
          :label="$t('devices.macAddress')"
          :rules="{ required: true, min: 1, max: 17, regex:/^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/ }"

          hideDetails
          outlined
          data-cy="productSensorForm-model"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VSelect
          v-model="data.connectionType"
          itemValue="key"
          required
          :label="$t('devices.connectionType')"
          :items="devicesList"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { CONNECTION_TYPES, AQ_GATEWAY } from '@/aquassist-shared/constants/types/deviceConnection';
import { mapGetters } from 'vuex';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import deviceHubMake from '@/constants/deviceHubMake';


export default {
    name: 'ProductSensorForm',
    components: {
        VSelect,
        VTextField,
    },
    props: {
        productSensorHub: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {
                name: '',
                make: 'Aquassist',
                model: '',
                macAddress: '',
                connectionType: AQ_GATEWAY,
            },
            makes: deviceHubMake,
        };
    },

    computed: {
        ...mapGetters([
            'site',
        ]),
        devicesList() {
            return CONNECTION_TYPES.map(item => ({
                key: item,
                name: this.$t(`devices.productSensorHubs.connectionType.${item}`),
            }));
        },
    },

    async created() {
        if (this.productSensorHub) {
            const oneProductSensorHub = await this.$rq.getProductSensorsHub(this.site.id, this.productSensorHub.id);
            this.data = oneProductSensorHub.data;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};

</script>

<style lang="scss" scoped>
    .content {
        min-width: 300px
    }

</style>
